import { NODE_TYPE_MULTI_SELECT } from '../../../utils/types/nodeTypes';
import { findNodes } from './helpers';

export function getMultiselectPaths(treeData) {
  return findNodes({
    treeData,
    searchMethod: (ni) => ni.node.type === NODE_TYPE_MULTI_SELECT,
  }).matches.map((m) => m.path);
}
